// Shared full-viewport loading spinner (styles in styles/index.css).
export default function LoadingOverlay({ label = 'avatar', children }) {
  return (
    <div className="loading-overlay" data-testid="loading-overlay">
      <div className="loading-spinner"></div>
      <div>Loading {label}…</div>
      {children}
    </div>
  )
}
